var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSafepal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1261152881"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M35.0716 0C32.6368 -2.25358e-07 30.3018 0.967232 28.5802 2.6889L1.53643 29.7332C0.512134 30.7574 -8.38607e-06 32.1 1.02989e-10 33.4426C8.38626e-06 34.785 0.512166 36.1276 1.53646 37.152L19.2591 54.8746V23.499C19.2591 21.1576 21.1424 19.2594 23.4838 19.2594C33.3762 19.2594 57.4556 19.2594 60.7402 19.2594L79.9992 0.000272944L35.0716 0Z",
    fill: "#4A21EF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19.2591 60.7409H56.5006C58.842 60.7409 60.7402 58.8427 60.7402 56.5011V25.1255L78.4628 42.8483C79.487 43.8727 79.9992 45.2151 79.9992 46.5577C79.9992 47.9003 79.487 49.2427 78.4628 50.2671L51.419 77.3113C49.6974 79.0329 47.3624 80.0003 44.9276 80.0003L0 79.9999L19.2591 60.7409Z",
    fill: "#4A21EF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafepal);
export default __webpack_public_path__ + "static/media/safepal.89e63c220caaedba7cc1c792565d4b0f.svg";
export { ForwardRef as ReactComponent };